<!-- @format -->

<div class="contextual-notification {{ variant }}">
  @if (icon) {
    <sis-icon [icon]="icon" aria-hidden="true"></sis-icon>
  }
  <div class="content-text">
    <span class="visually-hidden">{{ ariaVariantText | translate }}</span>
    {{ content }}
    <ng-content></ng-content>
  </div>
</div>
